import { isFieldVisible, VisibleWhen } from "../../../../utils/fieldVisibility";

/**
 * The site page's connection fields (vmsVariables rows: [label, value, id,
 * type, options, visible_when]) that pass their visible_when rule against the
 * current site values (ENG-2535). Each entry keeps its index into
 * vmsVariables, which the edit-mode builder writes back through. Hidden rows
 * keep their values; nothing is cleared or patched.
 */
export const visibleVmsVariables = (
  vmsVariables: any[],
  siteInfo: object | null | undefined
): { array: any[]; index: number }[] =>
  (vmsVariables || [])
    .map((array: any[], index: number) => ({ array, index }))
    .filter(({ array }) =>
      isFieldVisible(array?.[5] as VisibleWhen | undefined, siteInfo)
    );
